/* esm.sh - applesauce-common@5.2.0/dist/operations/wrapped-message */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/wrapped-message.mjs";
